import { MediaMovieApiModel } from '@era/inroom-sdk';

import { Action } from '@ngrx/store';

export enum MoviesActionTypes {
  LOAD_MOVIES = '[Movies] Load movies',
}

export class LoadMovies implements Action {
  readonly type = MoviesActionTypes.LOAD_MOVIES;

  constructor(public payload: MediaMovieApiModel[]) {}
}

export type MoviesActionsUnion = LoadMovies;
